import { surveyStatusOptions } from "../../../constants";
import { Label, Option, Select } from "./styles";

export default function SurveyStatusSelect({ selectedStatus, onChangeSelectedStatus }) {

  const handleChangeStatus = (e) => {
    const newStatus = surveyStatusOptions.find(status => +status.id === +e.target.value);

    onChangeSelectedStatus(newStatus);
  }

  return (
    <Label>
      <span>Status</span>
      <Select value={selectedStatus?.id} onChange={handleChangeStatus}>
        {surveyStatusOptions.map(status => {
          return <Option key={status.id} value={status.id} title={status.tooltip}>{status.name}</Option>
        })}
      </Select>
    </Label>
  );
}